// extracted by mini-css-extract-plugin
export default {"bodyLogin":"LoginPage_bodyLogin__XLAzQ","pass":"LoginPage_pass__6WAes"};